import { Text, View } from "@react-pdf/renderer";
import React from "react";

export default function ShipmentPdfInfo({ styles, shipment }) {
  /*   All States
   ********************************************* */
  const shippingAddress =
    typeof shipment?.shippingAddress === "string"
      ? JSON.parse(shipment?.shippingAddress)
      : shipment?.shippingAddress;

  const customerId = shipment?.customer?.customerId || "";
  const customerName = shipment?.customer?.customerName || "N/A";

  // Format shipping address as single line
  const formatShippingAddress = () => {
    if (!shippingAddress) return "N/A";

    const parts = [
      shippingAddress.addressLine1,
      shippingAddress.addressLine2,
      shippingAddress.city,
      shippingAddress.state,
      shippingAddress.zip,
      shippingAddress.country,
    ].filter(Boolean);

    return parts.join(", ");
  };

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */
  return (
    <>
      <View
        style={
          {
            //   marginTop: 10,
            // paddingVertical: 8,
          }
        }
      >
        {/* Customer */}
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={[styles.textbody, { fontWeight: "bold" }]}>
            Customer: {customerId ? `C-${customerId} ` : ""}
            {customerName}
          </Text>
        </View>

        {/* Shipping Address */}
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={[styles.textbody]}>
            <Text style={{ fontWeight: "bold" }}>Shipping Address: </Text>
            {formatShippingAddress()}
          </Text>
        </View>

        {/* Shipping Method and Courier Service on same line */}
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={[styles.textbody]}>
            <Text style={{ fontWeight: "bold" }}>Shipping Method: </Text>
            {shipment?.shippingMethod?.shippingMethod || "N/A"}
          </Text>
          <Text style={[styles.textbody, { marginLeft: 80 }]}>
            <Text style={{ fontWeight: "bold" }}>Courier Service: </Text>
            {shipment?.courierService?.name || "N/A"}
          </Text>
          <Text style={[styles.textbody, { marginLeft: 80 }]}>
            <Text style={{ fontWeight: "bold" }}>Tracking No#: </Text>
            {shipment?.trackingNo || "N/A"}
          </Text>
        </View>
      </View>
    </>
  );
}
